import { render, staticRenderFns } from "./formArticle.vue?vue&type=template&id=9fce37fa&scoped=true&"
import script from "./formArticle.vue?vue&type=script&lang=js&"
export * from "./formArticle.vue?vue&type=script&lang=js&"
import style0 from "./formArticle.vue?vue&type=style&index=0&id=9fce37fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fce37fa",
  null
  
)

export default component.exports